import { render, staticRenderFns } from "./VerifyPhoneNumberModal.vue?vue&type=template&id=1371031d&scoped=true&"
import script from "./VerifyPhoneNumberModal.vue?vue&type=script&lang=js&"
export * from "./VerifyPhoneNumberModal.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhoneNumberModal.vue?vue&type=style&index=0&id=1371031d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371031d",
  null
  
)

export default component.exports